<template>
  <v-row>
    <v-col md="12">
      <v-autocomplete
        v-model="select"
        :loading="loading"
        :items="items"
        :search-input.sync="search"
        :filter="filterObject"
        item-text="Problema"
        item-value="IdProblema"
        no-filter
        flat
        hide-no-data
        hide-details
        label="Diagnostico"
        placeholder="Diagnostico"
        outlined
        dense
        persistent-hint
        return-object
        :readonly="readonly"
        @change="selected"
      >
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
import API from "@/lib/API";
import { debounce } from "../../lib/debounce";
export default {
  props: {
    entidad: { type: Object },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      items: [],
      search: null,
      select: null,
      seleccionado: false,
    };
  },
  created() {
    this.debouncedFetch = debounce((newValue) => {
      if (newValue) {
        if (!this.seleccionado) {
          newValue = newValue.replace('/', '__')
          this.querySelections(newValue)
        } else {
          this.seleccionado = false
        }
      }
    }, 500)
  },
  watch: {
    search(val) {
      this.debouncedFetch(val)
      // if (val) {
      //   if (!this.seleccionado) {
      //     val = val.replace("/", "__");
      //     this.querySelections(val);
      //   } else {
      //     this.seleccionado = false;
      //   }
      // }
    },
    select() {
      if (this.select) {
        this.$emit("input", this.select);
      } else {
        this.$emit("input", undefined);
      }
    },
    entidad() {
      this.seleccionado = true;
      this.items.push(this.entidad);
      this.select = this.entidad;
    },
  },
  methods: {
    querySelections(v) {
      this.loading = true;
      API.Diagnostico.Buscar(v).then((data) => {
        this.loading = false;
        this.items = data;
      });
    },
    filterObject(item, queryText, itemText) {
      if (queryText) {
        return (
          item.Problema.toLocaleLowerCase().indexOf(
            queryText.toLocaleLowerCase()
          ) > -1
        );
      }
    },
    selected() {
      this.seleccionado = true;
    },
  },
};
</script>
